export const currentVersion = 1;
export var ContentAsCodeType;
(function (ContentAsCodeType) {
    ContentAsCodeType["HOMEPAGE"] = "homepage";
    ContentAsCodeType["CHART"] = "chart";
    ContentAsCodeType["DASHBOARD"] = "dashboard";
    ContentAsCodeType["SQL_CHART"] = "sql_chart";
    ContentAsCodeType["SPACE"] = "space";
    ContentAsCodeType["AI_AGENT"] = "ai_agent";
    ContentAsCodeType["SCHEDULED_DELIVERY"] = "scheduled_delivery";
    ContentAsCodeType["ALERT"] = "alert";
    ContentAsCodeType["GOOGLE_SHEETS_SYNC"] = "google_sheets_sync";
    ContentAsCodeType["VIRTUAL_VIEW"] = "virtual_view";
    ContentAsCodeType["EXTERNAL_CONNECTION"] = "external_connection";
})(ContentAsCodeType || (ContentAsCodeType = {}));
//# sourceMappingURL=core.js.map